export async function createGuideUseCase(guide_data, guideRepostitory) {
    const result = await guideRepostitory.create_guide(guide_data);

    // const entity = new guideEntity({
    //   id: result.settings_guide.id,
    //   customer: result.settings_guide.client,
    //   shipping_service: result.settings_guide.shipping_service,
    //   account: result.settings_guide.shipping_account,
    //   guide: result.settings_guide.master_tracking_number,
    //   date: result.settings_guide.created_at.split("T")[0],
    //   weight: result.settings_guide.total_weight,
    //   packing: result.settings_guide.boxes_details[0].dimensions.length + " X " + result.settings_guide.boxes_details[0].dimensions.height + " X " + result.settings_guide.boxes_details[0].dimensions.width,
    //   volumetric_weight: result.settings_guide.volumetric_weight,
    //   origin: result.settings_guide.shipper.state,
    //   destination: result.settings_guide.consignee.state,
    //   zone: result.settings_guide.zone,
    //   extended_zone: result.charge.extended_zone_cost_charged != 0 ? "guide_detail.ext_zone_apply" : "guide_detail.ext_zone_not_apply",
    //   status: result.settings_guide.status_history,
    //   guide_charge: result.charge
    // })
    
    // if (!entity.isValid()) {
    //   throw new Error("external shipment inválido");
    // }

    return result;
}